var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar"},_vm._l((_vm.steps),function(step,index){return _c('div',{key:'progress-bar-step-' + index,class:[
      'step-item',
      { active: (index) === _vm.getCurrentStep },
      { complete: (index) < _vm.getCurrentStep } ]},[_c('div',{staticClass:"icon"},[_vm._v(_vm._s(_vm.stepNumber(index, _vm.getCurrentStep)))]),_c('div',{staticClass:"content"},[_c('span',{staticClass:"content-text"},[_vm._v(_vm._s(step))])])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }